import axios from "axios";
import { useQuery } from "react-query";
import { TranslateMethod } from "../common/models";

interface IUseTranslatorProps {
  type: TranslateMethod | undefined,
  arabicSearchQuery: string,
  romanizationSearchQuery: string
}

const getTranslations = async (word: string, type: string) => {
  return (
    await axios.get("/api/list-lemmas/", {
      params: {
        word: word,
        type: type,
      },
    })
  ).data;
};


export default function useTranslator(props: IUseTranslatorProps) {
  const { type, arabicSearchQuery, romanizationSearchQuery } = props;
  const {
    isLoading: isTranslating,
    data: translationResults,
    refetch: translate,
  } = useQuery(
    ["translate"],
    () => getTranslations(type == TranslateMethod.Arabic ? arabicSearchQuery : romanizationSearchQuery, type!.toString()),
    {
      onSuccess: (data: any) => {
        console.log("data : " + JSON.stringify(data));
      },
      enabled: false,
    }
  );

  return { isTranslating, translationResults, translate }
}
